<template>
	<div class="body">
		<div class="body-container" v-if="data">

			<div class="title-ctr">{{data.title}}</div>
			
			<div class="step-ctr">
				<div class="step-name">{{data.step}}</div>
				
				<div class="step-route" @click="clickRule(data.ruleRoute)">{{data.ruleRoute.title}}</div>
			</div>

			<div class="foctor-outer">
				<div class="outer-title">自然流失</div>
				
				<!-- <div class="factor-ctr">
					<label class="factor-name">{{data.oldData.title}}</label>
				
					<el-input class="factor-input" v-model="oldFactor" @input="oldFactorChange" type="number"
						:step="step"></el-input>
				
					<label class="factor-note">调整区间：{{data.oldData.min}}-{{data.oldData.max}}</label>
				</div>
				
				<div class="factor-ctr">
					<label class="factor-name">{{data.resignData.title}}</label>
				
					<el-input class="factor-input" v-model="resignFactor" @input="resignFactorChange" type="number"
						:step="step"></el-input>
				
					<label class="factor-note">调整区间：{{data.resignData.min}}-{{data.resignData.max}}</label>
				</div> -->
				
				<div class="factor-ctr">
					<label class="factor-name">{{data.flowData.title}}</label>
				
					<el-input class="factor-input" v-model="flowFactor" @input="flowFactorChange" type="number"
						:step="step"></el-input>
				
					<label class="factor-note">调整区间：{{data.flowData.min}}-{{data.flowData.max}}</label>
				</div>
				
			</div>

			<div class="foctor-outer">
				<div class="outer-title">高职需求</div>
				
				<div class="factor-ctr">
					<label class="factor-name">{{data.careerData.title}}</label>
				
					<el-input class="factor-input" v-model="careerFactor" @input="careerFactorChange" type="number"
						:step="step"></el-input>
				
					<label class="factor-note">调整区间：{{data.careerData.min}}-{{data.careerData.max}}</label>
				</div>
				
				<div class="factor-ctr">
					<label class="factor-name">{{data.highData.title}}</label>
				
					<el-input class="factor-input" v-model="highFactor" @input="highFactorChange" type="number"
						:step="step"></el-input>
				
					<label class="factor-note">调整区间：{{data.highData.min}}-{{data.highData.max}}</label>
				</div>		
			</div>
	
			<el-table :data="list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="新增需求" align="center" prop="employee_add" />
				<el-table-column label="流失补位" align="center" prop="employee_lost" />
				<el-table-column label="技能总需求" align="center" prop="employee_all" />
				<el-table-column label="高职需求" align="center" prop="employee_high" />
			</el-table>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>
<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog"
			align="center">
			
			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>
		
	
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
</el-dialog>
	</div>
</template>

<script>
	import {
		getMatchFocusPage,
		focusFactorChange
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				oldFactor: '',
				resignFactor: '',
				flowFactor: '',
				careerFactor: '',
				highFactor: '',
				data: null,
				list: null,
				step: 0.001,
								showIntroDialog: false,
								introDialog: null,
								variableType: {
									File: 2,
									Rich: 3
								}
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				// this.params['oldFactor'] = this.oldFactor;
				// this.params['resignFactor'] = this.resignFactor;
				this.params['flowFactor'] = this.flowFactor;
				this.params['careerFactor'] = this.careerFactor;
				this.params['highFactor'] = this.highFactor;
				return this.params;
			},

			requestData() {
				getMatchFocusPage(this.buildParams()).then(res => {
					let realData = res.data;
					// this.oldFactor = realData.oldData.value;
					// this.resignFactor = realData.resignData.value;
					this.flowFactor = realData.flowData.value;
					this.careerFactor = realData.careerData.value;
					this.highFactor = realData.highData.value;
					this.list = realData.list;
					this.data = realData;
				});
			},

			clickNext() {
				let path = '/calcu?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route){
				if (route.type == this.variableType.File){
					let path = route.path;
					window.open(path, '_blank')
				}else if(route.type == this.variableType.Rich){
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog(){
				this.showIntroDialog = false;
			},

			oldFactorChange(num) {
				this.skillFactor = this.getLimitValue(num, this.data.oldData.min, this.data.oldData.max)
				this.onFactorChange();
			},
			
			resignFactorChange(num) {
				this.skillFactor = this.getLimitValue(num, this.data.resignData.min, this.data.resignData.max)
				this.onFactorChange();
			},
			
			flowFactorChange(num) {
				this.skillFactor = this.getLimitValue(num, this.data.flowData.min, this.data.flowData.max)
				this.onFactorChange();
			},

			careerFactorChange(num) {
				this.skillFactor = this.getLimitValue(num, this.data.careerData.min, this.data.careerData.max)
				this.onFactorChange();
			},
			
			highFactorChange(num) {
				this.skillFactor = this.getLimitValue(num, this.data.highData.min, this.data.highData.max)
				this.onFactorChange();
			},
			getLimitValue(num, min, max){
				// 最小值限制
				if (num < min) {
					num = min;
				}
				
				// 最大值限制
				if (num > max) {
					num = max;
				}
				
				return num;
			},

			onFactorChange() {
				focusFactorChange(this.buildParams()).then(res => {
					this.list = res.data.list;
				})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "focus.scss";
</style>